/**
 * Module dependencies.
 */

import MobileSvg from 'src/assets/landingpage/mobile.svg';
import styled from 'styled-components';

/**
 * `Container` styled component.
 */

const Container = styled.div`
  flex-shrink: 0;
  height: 544px;
  position: relative;
  width: 327px;

  img {
    display: block;
    height: 100%;
    width: 100%;
  }

  @media (max-width: 1440px) {
    height: calc(544px * (100vw / 1440px));
    width: calc(327px * (100vw / 1440px));
  }

  @media (max-width: 767px) {
    display: flex;
    height: auto;
    justify-content: center;
    margin: 0 auto;
    max-width: 375px;
    width: 100%;
  }
`;

/**
 * Export `ReportMockup` component.
 */

export function ReportMockup() {
  return (
    <Container data-name={'mobile-device'}>
      <MobileSvg />
    </Container>
  );
}
